import React from 'react';
import './Rotaryinjec.css';
import Rotar from '../../../imgs/Rotarys.webp';

const Rotaryinjec = () => {
    return (
        <div className="Rotaryinj-container">
            <div className='Ordinarys'>
                <h2 className="Rotaryinj-title">About PowerJet IBM-R series Rotary Injection Blow Molding Machines:</h2>

                <div className="Rotaryinj-content">
                    <ul className="Rotaryinj-text">
                        <li>Easy for operation and maintenance.</li>
                        <li>The rotary part is controlled by servo motor, which ensures the rotary accuracy.</li>
                        <li>Reasonable and scientific mold structure to reduce the production inputs.</li>
                        <li>The appearance quality is perfect without parting line.</li>
                        <li>Suitable for the industry which is strict for the product appearance (LED bulb PC Cover,etc.)</li>
                    </ul>
                <p className="Rotaryinj-text">Compare with standard injection molding machine
                     with preforming at 1st step and then blowing, POWERJET IBM-R Series 
                     could one-step finish(preforming and blowing at the same time).
                     Shorten production time and enhance production capacity.</p>

                </div>
                <div className="Rotaryinj">
                    <img src={Rotar} alt="72 Cavity PET Preforms Machine" className="Rotaryinj-image" />
                </div>
              
                <p className="Rotaryinj-text">Powerjet also provides KII series high precision
                     injection molding machines to produce LED lamp PBT housings!</p>

            </div>

        </div>
    );
};

export default Rotaryinjec;
